export class MobileOnlyStubService {
  constructor(gaApp) {
    this.gaApp = gaApp
  }

  get hasAccess() {
    return this.checkAccess()
  }

  checkRealMobileDevice() {
    if (!import.meta.client) return false

    const userAgent = navigator.userAgent
    const platform = navigator.platform
    const vendor = navigator.vendor || ''

    // 1. Проверка User-Agent на настоящие мобильные устройства
    const realMobileRegex =
      /(?:iPhone|iPad|iPod|Android|BlackBerry|Windows Phone|webOS|Mobile|Tablet)/i
    const isUserAgentMobile = realMobileRegex.test(userAgent)

    // 2. Проверка на эмуляторы и десктопные браузеры
    const desktopIndicators = [
      /Chrome\/.*Safari/i.test(userAgent) &&
        /Windows|Mac|Linux|X11/i.test(userAgent),
      /Firefox/i.test(userAgent) && /Windows|Mac|Linux|X11/i.test(userAgent),
      /Safari/i.test(userAgent) &&
        /Mac/i.test(userAgent) &&
        !/Mobile/i.test(userAgent),
      /Edge/i.test(userAgent) && /Windows/i.test(userAgent),
      /Opera/i.test(userAgent) && /Windows|Mac|Linux/i.test(userAgent),
    ]

    const isDesktopBrowser = desktopIndicators.some((i) => i)

    // 3. Проверка платформы
    const desktopPlatforms =
      /Win32|Win64|Windows|MacIntel|Linux x86_64|Linux i686/i
    const isDesktopPlatform = desktopPlatforms.test(platform)

    // 4. Проверка разрешения экрана (эмуляторы часто имеют нестандартные соотношения)
    const screenWidth = screen.width
    const screenHeight = screen.height
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight

    // Слишком большое разрешение для мобильного
    const isTooHighResolution = screenWidth > 1920 || screenHeight > 1080

    // Окно браузера намного меньше экрана (признак эмуляции)
    const isEmulatedWindow =
      windowWidth < screenWidth * 0.8 && windowHeight < screenHeight * 0.8

    // 5. Проверка pointer capabilities
    const coarsePointer = window.matchMedia('(pointer: coarse)').matches
    const finePointer = window.matchMedia('(pointer: fine)').matches
    const anyPointerCoarse = window.matchMedia('(any-pointer: coarse)').matches

    // Настоящее мобильное устройство должно иметь только coarse pointer
    const hasOnlyCoarsePointer =
      (coarsePointer || anyPointerCoarse) && !finePointer

    // 6. Проверка touch событий
    const hasTouchSupport =
      'ontouchstart' in window && navigator.maxTouchPoints > 0

    // 7. Проверка на эмуляцию через DevTools
    const isDevToolsOpen = () => {
      const threshold = 160
      return (
        window.outerHeight - window.innerHeight > threshold ||
        window.outerWidth - window.innerWidth > threshold
      )
    }

    // 8. Проверка специфичных свойств мобильных устройств
    const hasMobileFeatures =
      'orientation' in window && 'onorientationchange' in window

    // 9. Проверка vendor (производителя браузера)
    const mobileVendors = /Apple Computer|Google Inc/i.test(vendor)

    // Собираем все проверки
    const checks = {
      isUserAgentMobile,
      isDesktopBrowser: !isDesktopBrowser,
      isDesktopPlatform: !isDesktopPlatform,
      isTooHighResolution: !isTooHighResolution,
      isEmulatedWindow: !isEmulatedWindow,
      hasOnlyCoarsePointer,
      hasTouchSupport,
      isDevToolsOpen: !isDevToolsOpen(),
      hasMobileFeatures,
      mobileVendors,
    }

    return Object.values(checks).filter(Boolean).length >= 7
  }

  checkIframe() {
    try {
      return window !== window.parent
    } catch (e) {
      return true
    }
  }

  checkAccess() {
    /** Пропускаем в режиме разработки */
    if (
      this.gaApp.config.get('devConfig') ||
      this.gaApp.stores.app.main.isDebug
    ) {
      return true
    }

    // TODO: удалить фичу
    // const isDesktopBlocked = this.gaApp.features.get(
    //   'gamePrizeDesktopBlocked',
    // )
    const isDesktop = !this.checkIframe() || !this.checkRealMobileDevice()

    return !isDesktop
  }
}
